import React from 'react';

import { Head, Label } from 'components/data-visualization/Table/SortingHead';
import Row from 'components/data-visualization/Table/Row';
import { Header } from 'components/data-containers/PositionsTable/shared/PositionsTable.style';

interface IChartTableHeader {
  isSmallScreen: boolean;
  showProductColumn: boolean;
  showCustomerColumn?: boolean;
  firstColumnAlign?: string;
}

const ChartTableHeader: React.FC<IChartTableHeader> = (props) => {
  const {
    isSmallScreen,
    showProductColumn,
    showCustomerColumn,
    firstColumnAlign = 'center',
  } = props;

  if (isSmallScreen) {
    return null;
  }

  return (
    <Head>
      <Row>
        <Header textAlign={firstColumnAlign}>
          <Label>Position</Label>
        </Header>
        {showProductColumn && (
          <Header>
            <Label>Product name</Label>
          </Header>
        )}
        <Header>
          <Label>Chart</Label>
        </Header>
        {showCustomerColumn && (
          <Header>
            <Label>Publisher</Label>
          </Header>
        )}
        <Header>
          <Label>Territory</Label>
        </Header>
      </Row>
    </Head>
  );
};

export default ChartTableHeader;
